export default "__VITE_ASSET__C4h34Rg$__"